import { render, staticRenderFns } from "./IdematComparisonModal.vue?vue&type=template&id=06b5d2f4&scoped=true"
import script from "./IdematComparisonModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./IdematComparisonModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./IdematComparisonModal.vue?vue&type=style&index=0&id=06b5d2f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b5d2f4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ImpactGoalEditIdematSearchBar: require('/home/runner/work/assessment-service/assessment-service/frontend/components/impact-goal/edit/IdematSearchBar.vue').default,IxButtonAction: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/button/Action.vue').default,IxSectionText: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/SectionText.vue').default})
